import TenantPicker from '../../TenantSelector/TenantPicker';
import { useOtherInfoContext } from '../OtherInfoContext';
import { isFieldReadOnly } from '../fieldReadOnly';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

export const TenantSelectorField = ({
  field,
  fieldValue,
  isFieldDisabled,
  isSaved,
  validationMessage,
  allOptionsObj,
}: FieldComponentProps & {
  allOptionsObj?: { current?: Record<string, string> };
}) => {
  const { params, handleOtherInfoChange } = useOtherInfoContext();
  const tenantId = Number(fieldValue);
  const id = Number.isFinite(tenantId) ? tenantId : undefined;
  const tenantName =
    field.lookupList && fieldValue != null && fieldValue !== ''
      ? allOptionsObj?.current?.[`${field.lookupList}_${fieldValue}`]
      : undefined;
  const disabled = isSaved || isFieldReadOnly(field) || isFieldDisabled;

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <TenantPicker
        getTenants={params.onFetchTenants}
        tenantId={id}
        tenantName={tenantName}
        disabled={disabled}
        ariaLabel={`Pick ${field.label ?? 'tenant'}`}
        onSelected={(tenant) =>
          handleOtherInfoChange(field.name, String(tenant.id))
        }
      />
    </FieldWrapper>
  );
};
